import { faAngleRight, faDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSInput } from 'bricks';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import React from 'react';
import { URLS } from 'services/urls';
import { ISignUpManager } from 'views/public/SignUp/useSignUpManager';
import TermsAndConditionsBlock from 'components/signup/TermsAndConditionsBlock';

export interface ISignupFormProps {
    signUpManager: ISignUpManager;
    showManualSignUpForm: () => void;
}

const SignupForm = ({ signUpManager, showManualSignUpForm }: ISignupFormProps) => {
    const {
        SSOSignUpEnabled,
        organizationName,
        isOrgNameValid,
        orgValidationSuccess,
        handleOrganizationNameChange,
        handleLinkedInSignUp,
    } = signUpManager;

    return (
        <div className="text-center">
            <h1 className="text-white mb-0">Create an account to see full insights.</h1>
            <TermsAndConditionsBlock />
            <div className="mx-auto mt-2">
                <NSInput
                    id="organizationName"
                    name="organizationName"
                    type="text"
                    placeholder="Get started with your organization name"
                    value={organizationName.value}
                    onChange={handleOrganizationNameChange}
                    className="DirectSignUp__Input"
                    autoComplete="organization"
                    invalid={!isOrgNameValid}
                />
            </div>
            <div className="DirectSignUp__Arrow">
                <FontAwesomeIcon icon={faDown} />
            </div>
            <div className="DirectSignUp__FormSubmit mx-auto">
                <NSButtonBase
                    color="secondary"
                    callback={handleLinkedInSignUp}
                    className="DirectSignUp__LinkedIn"
                    innerContentClassName="DirectSignUp__LinkedIn__Content"
                    disabled={!SSOSignUpEnabled}
                    dataTestId="linkedInButton"
                >
                    <span>
                        <img src={URLS.IMAGE_CLOUDFRONT_URL('socials/linkedin.png')} alt="LinkedIn" />
                        {' '}
                        Sign up with LinkedIn
                    </span>
                </NSButtonBase>
            </div>
            <div className="DirectSignUp__Divider">
                <hr className="DirectSignUp__DividerLine" />
                <span className="DirectSignUp__DividerText">OR</span>
                <hr className="DirectSignUp__DividerLine" />
            </div>
            <div className="DirectSignUp__FullWidth">
                <NSButtonBase
                    outline
                    color="primary"
                    callback={showManualSignUpForm}
                    className="DirectSignUp__Button"
                    disabled={!orgValidationSuccess}
                    dataTestId="createAccountButton"
                >
                    Create account with my email
                </NSButtonBase>
            </div>
            <div className="mt-2 text-white">
                <span>
                    Already have an account?
                    {' '}
                    <a
                        href="/"
                        className="cursor-pointer"
                        rel="noopener noreferrer"
                    >
                        Sign in
                        <FontAwesomeIcon icon={faAngleRight} className="ml-1" />
                    </a>
                </span>
            </div>
        </div>
    );
};

export default SignupForm;
